import React from "react";

export default function Base({}) {
	return <>
		<path d="M100 49C100 76.1111 77.551 98 50 98C22.3356 98 0 76.1111 0 49C0 21.8889 22.3356 0 50 0C77.6644 0 100 21.8889 100 49Z"/>
	</>
}